import React, {useState, useEffect} from 'react';
import Select from './select';

const LIST_SINGLE = (props) => {
    const { question, onAnswer, questionIndex } = props;
    const [ answer, setAnswer ] = useState(null);

    return (
        <div>
            {question.options.map((option, index) => {
                const oProps = onAnswer ? { option: JSON.parse(option), answer, setAnswer, onAnswer, questionIndex } : { option: JSON.parse(option), answer, setAnswer, };
                return (
                    <Select {...oProps} key={"option-" + index} isSingle />
                )
            })}
        </div>
    )
}

export default LIST_SINGLE;